import { compose, lookupMessage, gracefullyLookupMessage } from "./dictionary.js";
import { dictionary_ca } from "./ca/index.js";
import { dictionary_de } from "./de/index.js";
import { dictionary_en } from "./en/index.js";
import { dictionary_es } from "./es/index.js";
import { dictionary_fr } from "./fr/index.js";
import { dictionary_it } from "./it/index.js";
import { dictionary_nl } from "./nl/index.js";
import { dictionary_pt } from "./pt/index.js";
import { Locale, toLocale } from "./translatable.js";
export const dictionaries = {
    [Locale.ca]: {},
    [Locale.de]: {},
    [Locale.en]: {},
    [Locale.es]: {},
    [Locale.fr]: {},
    [Locale.it]: {},
    [Locale.nl]: {},
    [Locale.pt]: {},
};
export const addToDictionary = (locale, dictionary) => {
    //  console.log(`Dictionary ${locale} ${dictionaries[locale]? ` has ${Object.keys(dictionaries[locale]).length} toplevel entries`: 'is UNDEFINED'}`)
    dictionaries[locale] = dictionaries[locale] ? compose(dictionaries[locale], dictionary) : dictionary;
    return dictionaries[locale];
};
addToDictionary(Locale.ca, dictionary_ca);
addToDictionary(Locale.de, dictionary_de);
addToDictionary(Locale.en, dictionary_en);
addToDictionary(Locale.es, dictionary_es);
addToDictionary(Locale.fr, dictionary_fr);
addToDictionary(Locale.it, dictionary_it);
addToDictionary(Locale.nl, dictionary_nl);
addToDictionary(Locale.pt, dictionary_pt);
export { lookupMessage, gracefullyLookupMessage, Locale, toLocale };
